import isEmpty from 'lodash/isEmpty';

import { IUser, IUserData, IUserSettings, UserActions, UserActionsEnum } from 'store/reducers/userReducer/userTypes';
import { STORAGE_KEYS } from 'utils/constants/constants';
import { EThemes } from 'types/commonEnums';
import { EAccountStatuses } from 'types/userTypes';
import { ECommonActions } from 'store/reducers/types';

const isCollapsedLeftPanel = JSON.parse(localStorage.getItem(STORAGE_KEYS.leftPanel) || 'false');
const theme = localStorage.getItem(STORAGE_KEYS.theme) || EThemes.Light;

const initialState: IUser = {
  isLoading: true,
  isAuthenticated: false,
  data: {} as IUserData,
  settings: {
    theme,
    isCollapsedLeftPanel,
    isUpdated: false,
    approvalStatus: EAccountStatuses.Initial,
    isOnboardingFinished: false,
    onBoardingSteps: Array(5).fill(false),
  } as IUserSettings,
};

export default function(state = initialState, action: UserActions): IUser {
  switch (action.type) {
    case UserActionsEnum.SET_CURRENT_USER: {
      return {
        ...state,
        data: { ...state.data, ...action.payload?.data },
        isLoading: action.payload?.isLoading || false,
        isAuthenticated: !isEmpty(action.payload.data?.permissions),
      };
    }

    case UserActionsEnum.UPDATE_USER: {
      return { ...state, data: { ...state.data, ...action.payload } };
    }

    case UserActionsEnum.SET_THEME:
    case UserActionsEnum.SET_LEFT_PANEL:
    case UserActionsEnum.GET_USER_SETTINGS: {
      return { ...state, settings: { ...state.settings, ...action.payload } };
    }

    case ECommonActions.CleanStore: {
      return { ...initialState, isLoading: false };
    }

    default:
      return state;
  }
}
